import { useState, useEffect, useRef, RefObject } from 'react'

interface ContainerSize {
  width: number
  height: number
}

const useContainerSize = <T extends HTMLElement = HTMLDivElement>(): [RefObject<T | null>, ContainerSize] => {
  const elementRef = useRef<T>(null)
  const [size, setSize] = useState<ContainerSize>({
    width: 0,
    height: 0,
  })

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.contentRect
        setSize({ width, height })
      }
    })

    resizeObserver.observe(element)

    const rect = element.getBoundingClientRect()
    setSize({ width: rect.width, height: rect.height })

    return () => {
      resizeObserver.disconnect()
    }
  }, [])

  return [elementRef, size]
}

export default useContainerSize
